import { Box, TextField } from '@material-ui/core'
import Autocomplete from '@mui/material/Autocomplete'
import { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'
import Api from '../../../Apis/api.service'
import { injectFormData } from '../../../utils'

const ReferenceInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  reference,
  optionLabel,
  optionValue,
  setErrors,
  errors,
  ...props
}) => {
  const translate = useTranslate()
  const [options, setOptions] = useState([])
  const [value, setValue] = useState({})
  const sort = props.sort ? props.sort : { field: 'id', order: 'DESC' }

  const getListReferences = async (params = { sort: {}, filter: {} }) => {
    const res = await Api.references.getListReferences(reference, {
      filter: JSON.stringify(params.filter),
      sort: JSON.stringify(params.sort),
    })
    if (res.status == 200) {
      setValue(() => {
        return res.data.find((item) => item[optionValue] == record[source])
      })
      setOptions([...res.data])
    } else {
      setOptions([])
    }
  }
  useEffect(() => {
    const filter = injectFormData(record, props.filter)
    console.log({ props, filter, value: record[source] })
    getListReferences({
      sort: { ...sort },
      filter: { ...filter },
    })
  }, [])

  return (
    <Autocomplete
      disablePortal
      id={`${reference}-combox`}
      options={options}
      value={value}
      onChange={(event, newValue) => {
        if (required && !newValue) {
          setErrors(() => {
            return errors.map((err) => {
              return err.id == props.id
                ? {
                    id: props.id,
                    source: source,
                    type: type,
                    label: label,
                  }
                : err
            })
          })
        } else {
          setErrors(() => {
            return errors.filter((item) => item.id !== props.id)
          })
        }
        setValue(newValue)
        setPayload({ ...payload, [source]: newValue[optionValue] })
      }}
      fullWidth
      getOptionLabel={(option) => option[optionLabel]}
      renderOption={(props, option) => (
        <Box component="li" sx={{}} {...props}>
          {option[optionLabel]}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          required={required}
          error={required && errors.find((item) => item.id == props.id)}
          {...params}
          label={translate(label, { _: label })}
          inputProps={{
            ...params.inputProps,
          }}
        />
      )}
    />
  )
}

export default ReferenceInput
